import { createContext, useContext } from 'react'

export type KeyType = string | null
interface ContextType {
  hlKey: KeyType
  isMatch: boolean
  update: (hlKey: KeyType, setIsMatch?: boolean) => void
}
export const HighlightContext = createContext<ContextType>({
  hlKey: null,
  isMatch: true,
  update: () => {
    throw Error('not implemented')
  },
})

export function useHighlightContext() {
  const { hlKey, isMatch, update } = useContext(HighlightContext)

  return { hlKey, isMatch, update }
}
